import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Divider = styled.div`
  height: 1px;
  width: ${(p) => (p.padding ? 'calc(100% + ' + p.padding * 2 + 'px)' : '100%')};
  margin-left: ${(p) => (p.padding ? -p.padding + 'px' : 'initial')};
  background-color: ${Colors.whisper};
`;

export const ShortDivider = styled.div`
  height: 1px;
  margin: 0 auto;
  background-color: ${Colors.whisper};
  padding: ${(p) => p.padding || '10px'};
  width: ${(p) => (p.padding ? 'calc(100% - ' + p.padding * 2 + 'px' : 'calc(100% - 20px)')};
`;
